<template>
  <div class="container">
    <guest-header />

    <section>
      <div class="about-wrapper">
        <div class="about-banner">
          <div
            v-if="!isMobile"
            class="about-caption"
          >
            <h2>
              WE <span>GUARANTEE</span> YOU A GREAT EXPERIENCE <br>ANY TIME YOU PROCURE <span>BID BONDS WITH US</span>
            </h2>
          </div>
        </div>

        <div class="about-description">
          <div class="content-description">
            <h3>Sidian Credible</h3>
            <p>At Sidian our mission is to empower businesses to create wealth through the provision of transformational financial solutions such as Sidian Credible.</p>
            <p>Sidian Credible is an online Bid bond procurement platform.</p>
            <p>With Sidian Credible, we give you the backing to execute the obligation of your contracts without the hassle.</p>
            <p>Sidian Credible enables you to;</p>
            <ul>
              <li>Provide assurance that the financial instrument secured through this platform is authentic.</li>
              <li>Participate in the local tendering process without the hassle.</li>
            </ul>
            <p />
          </div>

          <div class="about-lists">
            <h1>
              <span>SIDIAN CREDIBLE</span> OFFERS YOU SECURE BONDS AT THE BEST MARKET RATES
            </h1>
          </div>
        </div>
      </div>
    </section>

    <guest-footer />
  </div>
</template>

<script>
    import GuestHeader from "@/components/Guest/Header.vue";
    import GuestFooter from "@/components/Guest/Footer.vue";

    export default {
        components: {
            GuestHeader, GuestFooter
        },
      computed:{
        isMobile(){
          if (screen.width < 760)
            return true;
          else
            return false;
        }
      },

        mounted() {
            require('@/theme/js/script');
        },
      methods:{

      }
    }
</script>
